import {
  build_products,
  checkout_cta_label,
  product_contents,
  VALIDITY_LABEL,
  VALIDITY_MONTHS,
} from './products';
import { build_order } from './order';

// site resources
export {
  build_products,
  checkout_cta_label,
  product_contents,
  VALIDITY_LABEL,
  VALIDITY_MONTHS,
  build_order,
};
